import React from "react";
import Modal, { ModalTransition } from "@atlaskit/modal-dialog";
import apiClient from "../../api/admin-api-client";
import { toast } from "react-toastify";
import useAsync from "../../hooks/use-async";
import { useTranslation } from "react-i18next";

export default function UnblockUserDate({ user, onUnblocked, onClose }) {
    const { t } = useTranslation();
    const { run, isPending } = useAsync();
    const remove = () => {
        run(apiClient(`user/${user.id}/unblock`, { method: "PATCH"}))
            .then(() => {
                toast.success(t("admin_unblock_user_success"));
                onUnblocked && onUnblocked();
            })
            .catch(error => toast.error(t("admin_unblock_user_error") +  error.message));
    };

    return (
        <>
            <ModalTransition>
                <Modal
                    isLoading={isPending}
                    actions={[
                        { text: t("admin_unblock_user_unblock"), onClick: remove, isLoading: isPending },
                        { text: t("admin_unblock_user_cancel"), onClick: onClose, isDisabled: isPending },
                    ]}
                    onClose={close}
                    heading={t("admin_unblock_user_heading")}
                >
                    <p>
                        {t("admin_unblock_user_p")}
                    </p>
                </Modal>
            </ModalTransition>
        </>
    );
}